// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { PackagesUtilOfferingPackagePriceFragmentDoc } from '../../../utils/__generated-gql-types__/packages.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SelectAPackageSizeModalOfferingPackagePriceFragment = {
  __typename?: 'OfferingPackagePrice';
  sku?: string | null;
  tier?: Types.SkuTier | null;
  price: number;
  description?: string | null;
  numberPurchased: number;
  packageCoachingTime?: {
    __typename?: 'PackageCoachingTime';
    exactTimeInMinute?: number | null;
    estimate?: {
      __typename?: 'IntRange';
      start?: number | null;
      end?: number | null;
    } | null;
  } | null;
};

export type SelectAPackageSizeModalOfferingPackageFragment = {
  __typename?: 'OfferingPackage';
  id: string;
  name: string;
  deliverables?: Array<string> | null;
  imageLink?: string | null;
  isUniversalPackage: boolean;
  version: number;
  prices?: Array<{
    __typename?: 'OfferingPackagePrice';
    sku?: string | null;
    tier?: Types.SkuTier | null;
    price: number;
    description?: string | null;
    numberPurchased: number;
    freeLelandPlusPeriod?: {
      __typename?: 'TimePeriod';
      amount: number;
      unit: Types.TimeUnit;
    } | null;
    packageCoachingTime?: {
      __typename?: 'PackageCoachingTime';
      exactTimeInMinute?: number | null;
      estimate?: {
        __typename?: 'IntRange';
        start?: number | null;
        end?: number | null;
      } | null;
    } | null;
  }> | null;
  category?: {
    __typename?: 'Category';
    id: string;
    name: string;
    goal: Types.GoalName;
  } | null;
  coach: {
    __typename?: 'Coach';
    id: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
    };
  };
};

export type SelectAPackageSizeModalFindSkuQueryVariables = Types.Exact<{
  tier: Types.SkuTier;
}>;

export type SelectAPackageSizeModalFindSkuQuery = {
  __typename?: 'Query';
  findSkuBySession: { __typename?: 'Sku'; id: string; price: number };
};

export const SelectAPackageSizeModalOfferingPackagePriceFragmentDoc = gql`
  fragment SelectAPackageSizeModal_OfferingPackagePrice on OfferingPackagePrice {
    sku
    tier
    price
    description
    packageCoachingTime {
      estimate {
        start
        end
      }
      exactTimeInMinute
    }
    numberPurchased
  }
`;
export const SelectAPackageSizeModalOfferingPackageFragmentDoc = gql`
  fragment SelectAPackageSizeModal_OfferingPackage on OfferingPackage {
    id
    name
    deliverables
    imageLink
    prices {
      freeLelandPlusPeriod {
        amount
        unit
      }
      ...SelectAPackageSizeModal_OfferingPackagePrice
      ...PackagesUtil_OfferingPackagePrice
    }
    category {
      id
      name
      goal
    }
    coach {
      id
      user {
        id
        firstName
        lastName
        pictureLink
      }
    }
    isUniversalPackage
    version
  }
  ${SelectAPackageSizeModalOfferingPackagePriceFragmentDoc}
  ${PackagesUtilOfferingPackagePriceFragmentDoc}
`;
export const SelectAPackageSizeModalFindSkuDocument = gql`
  query SelectAPackageSizeModal_FindSku($tier: SkuTier!) {
    findSkuBySession(numberOfSessions: 1, tier: $tier, period: ONE_TIME) {
      id
      price
    }
  }
`;

/**
 * __useSelectAPackageSizeModalFindSkuQuery__
 *
 * To run a query within a React component, call `useSelectAPackageSizeModalFindSkuQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectAPackageSizeModalFindSkuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectAPackageSizeModalFindSkuQuery({
 *   variables: {
 *      tier: // value for 'tier'
 *   },
 * });
 */
export function useSelectAPackageSizeModalFindSkuQuery(
  baseOptions: Apollo.QueryHookOptions<
    SelectAPackageSizeModalFindSkuQuery,
    SelectAPackageSizeModalFindSkuQueryVariables
  > &
    (
      | {
          variables: SelectAPackageSizeModalFindSkuQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SelectAPackageSizeModalFindSkuQuery,
    SelectAPackageSizeModalFindSkuQueryVariables
  >(SelectAPackageSizeModalFindSkuDocument, options);
}
export function useSelectAPackageSizeModalFindSkuLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SelectAPackageSizeModalFindSkuQuery,
    SelectAPackageSizeModalFindSkuQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SelectAPackageSizeModalFindSkuQuery,
    SelectAPackageSizeModalFindSkuQueryVariables
  >(SelectAPackageSizeModalFindSkuDocument, options);
}
export function useSelectAPackageSizeModalFindSkuSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SelectAPackageSizeModalFindSkuQuery,
    SelectAPackageSizeModalFindSkuQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SelectAPackageSizeModalFindSkuQuery,
    SelectAPackageSizeModalFindSkuQueryVariables
  >(SelectAPackageSizeModalFindSkuDocument, options);
}
export type SelectAPackageSizeModalFindSkuQueryHookResult = ReturnType<
  typeof useSelectAPackageSizeModalFindSkuQuery
>;
export type SelectAPackageSizeModalFindSkuLazyQueryHookResult = ReturnType<
  typeof useSelectAPackageSizeModalFindSkuLazyQuery
>;
export type SelectAPackageSizeModalFindSkuSuspenseQueryHookResult = ReturnType<
  typeof useSelectAPackageSizeModalFindSkuSuspenseQuery
>;
export type SelectAPackageSizeModalFindSkuQueryResult = Apollo.QueryResult<
  SelectAPackageSizeModalFindSkuQuery,
  SelectAPackageSizeModalFindSkuQueryVariables
>;
